<template>
  <v-container fluid >

    <v-row v-if="loading && isEditor">
      <v-col cols="12" >
        <h2>Accesso veloce</h2>
        <v-progress-linear indeterminate color="primary" height="1"></v-progress-linear>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2" v-for="i in 12" :key="`sk_${i}`">
        <v-skeleton-loader type="list-item-avatar-three-line"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row v-if="!loading && isEditor">
      <v-col cols="12" >
        <h2>Accesso veloce</h2>
        <v-divider />
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <stat icon="mdi-dumbbell" :value="dashboard.num_kits" title="pacchetti" to="/kits" ></stat>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <stat icon="mdi-run-fast" :value="dashboard.num_exercises" title="esercizi" to="/exercises" ></stat>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <stat icon="mdi-tag" :value="dashboard.num_categories" title="categorie" to="/categories" ></stat>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <stat icon="mdi-tag" :value="dashboard.num_subcategories" title="sottocategorie prodotto" to="/subcategories" ></stat>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <stat icon="mdi-alert" :value="dashboard.num_difficulties" title="difficoltà" to="/difficulties" ></stat>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <stat icon="mdi-gender-male-female" :value="dashboard.num_genre" title="generi" to="/genre" ></stat>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <stat icon="mdi-play-network" :value="dashboard.num_media" title="file media" to="/difmediaficulties" ></stat>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <stat icon="mdi-cart" :value="dashboard.num_sells" title="vendite" to="/sells" ></stat>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <stat icon="mdi-card-account-details" :value="dashboard.num_cards" title="tesserati MSP" to="/cards" ></stat>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <stat icon="mdi-account" :value="dashboard.num_users" title="utenti" to="/users" ></stat>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <stat icon="mdi-format-list-checks" :value="dashboard.num_reports" title="report utenti" to="/reports" ></stat>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <stat icon="mdi-tablet-dashboard" :value="dashboard.home_sections" title="sezioni homefitness" to="/home" ></stat>
      </v-col>
    </v-row>
    <v-row v-if="loading">
      <v-col cols="12" >
        <h2 class="my-0">Riepilogo prenotazioni</h2>
        <v-progress-linear indeterminate color="primary" height="1"></v-progress-linear>
      </v-col>
      <v-col cols="6" md="4" lg="3" v-for="i in 5" :key="`sk2_${i}`">
        <v-skeleton-loader type="list-item-avatar-three-line"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row v-if="!loading">
      <v-col cols="12">
        <h2 class="my-0">Riepilogo prenotazioni</h2>
        <v-divider />
      </v-col>
      <v-col cols="6" md="4" lg="3">
        <v-card class="white" @click="$router.push('/topgymexperience')">
          <v-card-text>
            <h2 class="my-0 d-inline-flex align-center">TOP GYM EXPERIENCE</h2>
            <p class="my-0 text-body-large text-uppercase mb-0">OGGI <strong>{{dashboard.today_bookings_exp}}</strong></p>
            <p class="my-0 text-body-large text-uppercase mb-0">DOMANI <strong>{{dashboard.tomorrow_bookings_exp}}</strong></p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" md="4" lg="3">
        <v-card class="white" @click="$router.push('/salacorsi')">
          <v-card-text>
            <h2 class="my-0 d-inline-flex align-center">SALA CORSI</h2>
            <p class="my-0 text-body-large text-uppercase mb-0">OGGI <strong>{{dashboard.today_bookings_corsi}}</strong></p>
            <p class="my-0 text-body-large text-uppercase mb-0">DOMANI <strong>{{dashboard.tomorrow_bookings_corsi}}</strong></p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" md="4" lg="3">
        <v-card class="white" @click="$router.push('/opengym')">
          <v-card-text>
            <h2 class="my-0 d-inline-flex align-center">OPEN GYM</h2>
            <p class="my-0 text-body-large text-uppercase mb-0">OGGI <strong>{{dashboard.today_bookings_opengym}}</strong></p>
            <p class="my-0 text-body-large text-uppercase mb-0">DOMANI <strong>{{dashboard.tomorrow_bookings_opengym}}</strong></p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" md="4" lg="3">
        <v-card class="white" @click="$router.push('/vacu')">
          <v-card-text>
            <h2 class="my-0 d-inline-flex align-center">VACU</h2>
            <p class="my-0 text-body-large text-uppercase mb-0">OGGI <strong>{{dashboard.today_bookings_vacu}}</strong></p>
            <p class="my-0 text-body-large text-uppercase mb-0">DOMANI <strong>{{dashboard.tomorrow_bookings_vacu}}</strong></p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" md="4" lg="3">
        <v-card class="white" @click="$router.push('/gym')">
          <v-card-text>
            <h2 class="my-0 d-inline-flex align-center">BIKE INDOOR</h2>
            <p class="my-0 text-body-large text-uppercase mb-0">OGGI <strong>{{dashboard.today_bookings_gym}}</strong></p>
            <p class="my-0 text-body-large text-uppercase mb-0">DOMANI <strong>{{dashboard.tomorrow_bookings_gym}}</strong></p>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>

    <v-row v-if="loading && isAdmin">
      <v-col cols="12" >
        <h2>Abbonamenti attivi</h2>
        <v-progress-linear indeterminate color="primary" height="1"></v-progress-linear>
      </v-col>
      <v-col cols="6" md="4" v-for="i in 7" :key="`sk3_${i}`">
        <v-skeleton-loader type="list-item-avatar-three-line"></v-skeleton-loader>
      </v-col>
      <v-col cols="12">
        <h2>Andamento vendite</h2>
        <v-progress-linear indeterminate color="primary" height="1"></v-progress-linear>
      </v-col>
      <v-col cols="12" md="6" v-for="i in 6" :key="`sk4_${i}`">
        <v-skeleton-loader type="image"></v-skeleton-loader>
      </v-col>

      <v-col cols="6" md="4" lg="3" v-for="i in 3" :key="`sk5_${i}`">
        <v-skeleton-loader type="list-item-avatar-three-line"></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row v-if="!loading && isAdmin">
      <v-col cols="12">
        <h2>Abbonamenti attivi</h2>
        <v-divider />
      </v-col>

      <v-col cols="6" md="4" v-for="k in activeKits" :key="k._id">
        <v-card class="white" @click="openSubDetail(k.title.it.toUpperCase(), getActiveByKit(k))">
          <v-card-text>
            <h2 class="my-0 d-inline-flex align-center">{{k.title.it.toUpperCase()}} ATTIVI</h2>
            <p class="my-0 text-body-large text-uppercase mb-0"><strong>{{getActiveByKit(k).length}}</strong> ad oggi</p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" md="4">
        <v-card class="white"  @click="openSubDetail('MAI UTILIZZATI', unusedSeats)">
          <v-card-text>
            <h2 class="my-0 d-inline-flex align-center">PACCHETTI A SCADENZA MAI UTILIZZATI</h2>
            <p class="my-0 text-body-large text-uppercase mb-0"><strong>{{unusedSeats.length}} PACCHETTI</strong></p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <h2>Andamento vendite</h2>
        <v-divider />
      </v-col>
      <v-col cols="12" md="6">
        <h4>N° pacchetti sedute venduti ultimi 7 giorni</h4>
        <v-sheet color="primary">
          <v-sparkline
              :model-value="dashboard.num_sells_seats_7_days"
              color="rgba(255, 255, 255, .7)"
              height="100"
              padding="24"
              stroke-linecap="round"
              smooth
          >
            <template v-slot:label="item">
              {{ item.value }}
            </template>
          </v-sparkline>
        </v-sheet>
      </v-col>
      <v-col cols="12" md="6">
        <h4>Ricavi pacchetti sedute ultimi 7 giorni</h4>
        <v-sheet color="primary">
          <v-sparkline
              :model-value="dashboard.sells_seats_7_days"
              color="rgba(255, 255, 255, .7)" height="100" padding="24" stroke-linecap="round" smooth>
            <template v-slot:label="item">
              {{ item.value }}€
            </template>
          </v-sparkline>
        </v-sheet>
      </v-col>
      <v-col cols="12" md="6">
        <h4>N° pacchetti home fitness venduti ultimi 7 giorni</h4>
        <v-sheet color="primary">
          <v-sparkline
              :model-value="dashboard.num_sells_fit_7_days"
              color="rgba(255, 255, 255, .7)" height="100" padding="24"
              stroke-linecap="round" smooth
          >
            <template v-slot:label="item">
              {{ item.value }}
            </template>
          </v-sparkline>
        </v-sheet>
      </v-col>
      <v-col cols="12" md="6">
        <h4>Ricavi pacchetti home fitness ultimi 7 giorni</h4>
        <v-sheet color="primary">
          <v-sparkline
              :model-value="dashboard.sells_fit_7_days"
              color="rgba(255, 255, 255, .7)"
              height="100" padding="24" stroke-linecap="round" smooth>
            <template v-slot:label="item">
              {{ item.value }}€
            </template>
          </v-sparkline>
        </v-sheet>
      </v-col>
      <v-col cols="12" md="6">
        <h4>Totale pacchetti venduti ultimi 7 giorni</h4>
        <v-sheet color="primary">
          <v-sparkline
              :model-value="dashboard.num_sells_7_days"
              color="rgba(255, 255, 255, .7)" height="100" padding="24"
              stroke-linecap="round" smooth
          >
            <template v-slot:label="item">
              {{ item.value }}
            </template>
          </v-sparkline>
        </v-sheet>
      </v-col>
      <v-col cols="12" md="6">
        <h4>Ricavi totali ultimi 7 giorni</h4>
        <v-sheet color="primary">
          <v-sparkline
              :model-value="dashboard.sells_7_days"
              color="rgba(255, 255, 255, .7)"
              height="100" padding="24" stroke-linecap="round" smooth>
            <template v-slot:label="item">
              {{ item.value }}€
            </template>
          </v-sparkline>
        </v-sheet>
      </v-col>




      <v-col cols="6" md="4" lg="3">
        <v-card class="white" @click="$router.push('/sells')">
          <v-card-text>
            <h2 class="my-0 d-inline-flex align-center">PACCHETTI SEDUTE</h2>
            <p class="my-0 text-body-large text-uppercase mb-0"><strong>{{dashboard.num_sells_seats}}</strong> venduti</p>
            <p class="my-0 text-body-large text-uppercase mb-0"><strong>{{dashboard.sells_seats.toFixed(2)}}€</strong> totali</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" md="4" lg="3">
        <v-card class="white" @click="$router.push('/sells')">
          <v-card-text>
            <h2 class="my-0 d-inline-flex align-center">PACCHETTI HOME FIT</h2>
            <p class="my-0 text-body-large text-uppercase mb-0"><strong>{{dashboard.num_sells_fit}}</strong> venduti</p>
            <p class="my-0 text-body-large text-uppercase mb-0"><strong>{{dashboard.sells_fit.toFixed(2)}}€</strong> totali</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" md="4" lg="3">
        <v-card class="white" @click="$router.push('/sells')">
          <v-card-text>
            <h2 class="my-0 d-inline-flex align-center">TOTALE</h2>
            <p class="my-0 text-body-large text-uppercase mb-0"><strong>{{dashboard.num_sells}}</strong> venduti</p>
            <p class="my-0 text-body-large text-uppercase mb-0"><strong>{{dashboard.sells.toFixed(2)}}€</strong> totali</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="detailDialog" max-width="1600" scrollable>
      <v-card>
        <v-card-title>{{detailDialogTitle}}</v-card-title>
        <v-card-text>
          <v-text-field v-model="detailDialogQ" label="Cerca per utente" clearable solo rounded hide-details style="max-width: 500px"></v-text-field>
          <v-table>
            <thead>
            <tr>
              <th class="text-left">
                Utente
              </th>
              <th class="text-left">
                Sedute nel pacchetto
              </th>
              <th class="text-left">
                Disponibilità
              </th>
              <th class="text-left">
                Prodotto
              </th>
              <th class="text-left">
                Data Acquisto
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="item in detailDialogItemsFilter"
                :key="item._id"
            >
              <td><a class="text-decoration-underline text-primary font-weight-bold" @click="$router.push('/users/'+item.user_id)">{{item.user_name}}</a></td>
              <td>
                <p class="mb-0">Tipologia sedute: <v-chip-group v-if="item.seats_types">
                  <v-chip small v-for="(st,j) in item.seats_types" :key="`${item._id}_seats_${j}`">{{getSeatsName(st)}}</v-chip>
                </v-chip-group></p>

              </td>
              <td>
                <p v-if="item.consumable" class="mb-0">N° sedute disponibili: {{item.available}}</p>
                <p v-if="item.consumable" class="mb-0">N° sedute consumate: {{item.used}}</p>
                <p class="mb-1">Durata: {{item.duration}} giorni</p>
                <p class="mb-1" v-if="item.expiration">Scadenza: {{formatDate(item.expiration)}}</p>
              </td>
              <td>
                <a v-if="item.product_id" class="text-decoration-underline text-primary font-weight-bold" @click="$router.push('/products/'+item.product_id)">{{getProductName(item.product_id)}}</a>
                <a v-else-if="item.purchase_id && getProduct(item.purchase_id)" class="text-decoration-underline text-primary font-weight-bold" @click="$router.push('/products/'+getProduct(item.purchase_id)!._id)">{{getProduct(item.purchase_id)!.title.it}}</a>
                <a v-else-if="item.purchase_id && getPurchase(item.purchase_id)" class="text-decoration-underline text-primary font-weight-bold">{{getPurchase(item.purchase_id)!.product_id}} (cancellato)</a>
                <span v-else>-</span>
              </td>
              <td>
                <a v-if="item.purchase_id" class="text-decoration-underline text-primary font-weight-bold" @click="$router.push('/purchases/'+item.purchase_id)">{{ getPurchaseDate(item.purchase_id) }}</a>
                <span v-else>-</span>
              </td>
            </tr>
            </tbody>
          </v-table>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="detailDialog = false;">Chiudi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import Stat from "@/components/Stat.vue";
import {computed, inject, onMounted, ref} from "vue";
import {type Dashboard, type KitDisplay, SeatsType, type UserSeat} from "@/models.ts";
import type {Globals} from "@/plugins/globals.ts";
import api from "@/api";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Auth} from "@/plugins/auth.ts";
import {DateTime} from "luxon";

export default {
  name: "Dashboard",
  components: {Stat},
  setup () {

    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals

    const loading = ref(false)
    const detailDialog = ref(false)
    const detailDialogTitle = ref('Lista abbonamenti attivi')
    const detailDialogItems = ref<UserSeat[]>([])
    const detailDialogQ = ref('')
    const validseats = ref<UserSeat[]>([])
    const dashboard = ref<Dashboard>({
      home_sections: 0,
      num_users : 0,
      num_kits : 0,
      num_exercises : 0,
      num_categories : 0,
      num_subcategories : 0,
      num_genre : 0,
      num_difficulties : 0,
      num_media : 0,
      num_cards : 0,
      num_reports : 0,
      today_bookings_exp : 0,
      tomorrow_bookings_exp : 0,
      today_bookings_corsi : 0,
      tomorrow_bookings_corsi : 0,
      today_bookings_vacu : 0,
      tomorrow_bookings_vacu : 0,
      today_bookings_gym : 0,
      tomorrow_bookings_gym : 0,
      today_bookings_opengym : 0,
      tomorrow_bookings_opengym : 0,
      num_sells_seats_7_days : [],
      num_sells_fit_7_days : [],
      num_sells_7_days : [],
      sells_seats_7_days : [],
      sells_fit_7_days : [],
      sells_7_days : [],
      num_sells_seats : 0,
      num_sells_fit : 0,
      num_sells : 0,
      sells_seats : 0,
      sells_fit : 0,
      sells : 0,
      this_month_exp_subscription : 0,
      this_month_vacu_subscription : 0,
      this_month_gym_subscription : 0,
      this_month_corsi_subscription : 0,
      this_month_open_gym_subscription : 0,
      num_unused_subscription : 0,

      exp_seats : [],
      vacu_seats : [],
      corsi_seats : [],
      open_gym_seats : [],
      gym_seats : [],
      unused_seats : []
    })

    const getUserName = (id:string) => {
      const user = globals.users.value.find(u => u._id === id)
      return user ? `${user.name} ${user.surname}` : `${id} (cancellato)`
    }

    const loadDashboard = async () => {

      const res = await api.getDashboard()
      if(!res.success) {
        if(res.status  == 401) {
          messages.error(res.message ?? Msg.permissionError)
          auth.logout()
          return
        }
        messages.error(res.message ?? Msg.serverError)
        return
      }
      dashboard.value = res.data!
    }

    onMounted(async ()=>{
      loading.value = true
      await Promise.all([
          globals.refresh('users'),
          globals.refresh('kits'),
          globals.refresh('products'),
          globals.refresh('purchases'),
          globals.refresh('userseats'),
          loadDashboard(),
      ])

      validseats.value = globals.userseats.value.filter(us => {
        if(!us.consumable) {
          if(!us.expiration) return true
          const dt = DateTime.fromISO(us.expiration)
          return dt > DateTime.now()
        }
        if(us.expiration) {
          const dt = DateTime.fromISO(us.expiration)
          if(dt < DateTime.now()) return false
        }
        return us.available > us.used
      })
      loading.value = false
    })

    return {
      loading,
      isEditor : auth.isEditor,
      isAdmin : auth.isAdmin,
      detailDialog,
      detailDialogTitle,
      detailDialogItems,
      detailDialogQ,
      validseats,
      dashboard,
      detailDialogItemsFilter : computed<UserSeat[]>(()=>{
        return detailDialogItems.value.map(i => {
          i.user_name = getUserName(i.user_id)
          return i
        }).filter(i => {
          if(!detailDialogQ.value) return true
          return i.user_name!.search(new RegExp(detailDialogQ.value, "i")) > -1
        })
      }),
      activeKits : computed(()=>{
        return globals.kits.value.filter(k => k.category && k.category._id === '60940ed27398889e2bebb889' && k.pub === true)
      }),
      unusedSeats : computed(()=>{
        return validseats.value.filter(us => !us.expiration)
      }),
      openSubDetail( title:string, items:UserSeat[] ) {
        detailDialogItems.value = items
        detailDialogTitle.value = `Lista abbonamenti attivi "${title}"`;
        detailDialog.value = true
      },
      getActiveByKit(k:KitDisplay):UserSeat[] {
        const products = globals.products.value.filter(p => p.kit && p.kit._id === k._id && p.is_seats_product)
        //console.log("products", products.length)
        let seats:SeatsType[] = []
        for(let i = 0; i < products.length; i++) {
          const p = products[i]
          const st =  p.seats_types || []
          for(let j = 0; j < st.length; j++) {
            if(!seats.includes(st[j])) {
              seats.push(st[j])
            }
          }
        }
        return validseats.value.filter(us => utils.equalsCheck(us.seats_types, seats))
      },
      getProductName(id:string) {
        const product = globals.products.value.find(p => p._id === id)
        return product ? product.title.it : `${id} (cancellato)`
      },
      getProduct(purchaseId:string) {
        const pur = globals.purchases.value.find(p => p._id === purchaseId)
        if(!pur) return null
        return globals.products.value.find(p => p._id === pur.product_id)
        //return product ? product.title.it : `${pur.product_id} (cancellato)`
      },
      getPurchase(purchaseId:string) {
        return  globals.purchases.value.find(p => p._id === purchaseId)
      },
      getPurchaseDate(purchaseId:string) {
        const pur = globals.purchases.value.find(p => p._id === purchaseId)
        if(!pur) return '-'
        return utils.formatDateTime(pur.date)
      },
      getSeatsName( s:SeatsType ) {
        switch (s) {
          case SeatsType.exp:
            return "Top Gym Experience"
          case SeatsType.opengym:
            return "Open Gym"
          case SeatsType.corsi:
            return "Sala corsi"
          case SeatsType.gym:
            return "Bike indoor"
          case SeatsType.vacu:
            return "Vacu"
        }
      },
      formatDate : utils.formatDate,
    }
  },
}
</script>

<style scoped>

</style>